package fr.frux.core.designsystem.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Person
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * Avatar à initiale pour un pseudo connu, icône générique sinon (#206).
 *
 * [username] `null` (pseudo absent ou compte anonymisé, cf. `Tree.createdByUsername`) rend une
 * icône `Person` neutre plutôt que d'inventer une initiale — jamais un identifiant maquillé en nom.
 * [containerColor]/[contentColor] sont laissés à l'appelant : l'alternance de teinte entre plusieurs
 * avatars d'une même liste est une décision d'écran, pas de ce composant.
 *
 * PascalCase = convention Jetpack Compose officielle pour `@Composable`, patron déjà suivi par
 * tout le design system (`StatusBadge`, `FruxButton`...) ; ktlint ne le sait que sur les fichiers
 * dans le ratchet, d'où la suppression explicite plutôt qu'un renommage qui romprait la convention.
 */
@Composable
fun InitialsAvatar(
    username: String?,
    modifier: Modifier = Modifier,
    size: Dp = 32.dp,
    containerColor: Color = MaterialTheme.colorScheme.primaryContainer,
    contentColor: Color = MaterialTheme.colorScheme.onPrimaryContainer,
) {
    Box(
        modifier =
            modifier
                .size(size)
                .clip(CircleShape)
                .background(containerColor),
        contentAlignment = Alignment.Center,
    ) {
        if (username.isNullOrBlank()) {
            Icon(
                imageVector = Icons.Outlined.Person,
                contentDescription = null,
                tint = contentColor,
            )
        } else {
            Text(
                text = username.trim().first().uppercase(),
                style = MaterialTheme.typography.labelLarge,
                color = contentColor,
            )
        }
    }
}
